import moment from 'moment';
import type {Moment} from 'moment';

const pluralize = (value: number, unit: string) =>
  `${value} ${unit}${value === 1 ? '' : 's'}`;

// "1 year, 1 month, 15 days" — zero units are skipped. Recovery dates are
// stored at midnight UTC, so the diff is taken in UTC to avoid an off-by-one
// day for viewers west of UTC.
export const humanizeRecoveryDuration = (
  recoveryDate: string,
  now: Moment = moment.utc(),
): string => {
  const start = moment.utc(recoveryDate);

  const years = now.diff(start, 'years');
  start.add(years, 'years');
  const months = now.diff(start, 'months');
  start.add(months, 'months');
  const days = now.diff(start, 'days');

  if (years === 0 && months === 0 && days === 0) {
    return 'Started today';
  }

  const parts = [
    years > 0 && pluralize(years, 'year'),
    months > 0 && pluralize(months, 'month'),
    days > 0 && pluralize(days, 'day'),
  ].filter(Boolean);

  return parts.join(', ');
};
